import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";

import BreadcrumbBar from "./BreadcrumbBar";
import InputForm from "./InputForm";
import "./App.css";

class App extends Component {

	render() {
		return (
			<div>
				<Header />
				<BreadcrumbBar />
				<InputForm />
				<Footer />
			</div>
		);
	}
}

export default App;
